import React, { useEffect, useMemo, useState } from "react";

import { Eye, PencilSimple, Trash } from "phosphor-react";
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

// import { API } from "../../api/SampleResponse";
import API from "../../api";
import { Button, PageBreadCrumbs, SkeletonTableView, TableView, Tooltip } from "../../components";
import { RULE_TABS } from "./constants";
import { DataType } from "../../GlobalConstants";

export const RuleManagement = () => {
    const [activeRuleTab, setActiveRuleTab] = useState(RULE_TABS.ACTIVE.key)
    const [ruleData, setRuleData] = useState(null)
    const [ruleLoading, setRuleLoading] = useState(false);

    const navigate = useNavigate()

    const TableViewColumns = useMemo(() => [
        {
            name: "Rule Id",
            field: "id",
            type: DataType.TEXT
        },
        {
            name: "Name",
            field: "name",
            type: DataType.TEXT
        },
        {
            name: "Status",
            field: "status",
            type: DataType.TEXT
        },
        {
            name: "Start Date",
            field: "startDate",
            type: DataType.DATE
        },
        {
            name: "End Date",
            field: "endDate",
            type: DataType.DATE
        },
        {
            name: "Modified At",
            field: "updatedAt",
            type: DataType.DATE
        },
        {
            name: "Modified By",
            field: "updatedBy",
            type: DataType.TEXT
        },
        {
            name: "Created By",
            field: "createdBy",
            type: DataType.TEXT
        },
        {
            children: (rowData) =>
                <div className="flex items-center gap-5">
                    {activeRuleTab === RULE_TABS.DRAFT.key &&
                        <Tooltip className="tooltip-primary" message="Edit Rule" position="top">
                            <PencilSimple className="opacity-0 text-blue-500 group-hover:opacity-100" size={24} onClick={(evt) => {
                                evt?.stopPropagation()
                                if (rowData?.type && rowData?.id) {
                                    navigate(`rule/${rowData?.id}?mode=edit`)
                                }
                            }} />
                        </Tooltip>
                    }

                    <Tooltip className="tooltip-primary" message="View Rule" position="top">
                        <Eye className="opacity-0 text-primary group-hover:opacity-100" size={24} onClick={(evt) => {
                            evt?.stopPropagation()
                            navigate(`rule/${rowData?.id}?mode=view`)
                        }} />
                    </Tooltip>

                    {activeRuleTab !== RULE_TABS.INACTIVE.key &&
                        <Tooltip className="tooltip-primary" message="Delete Rule" position="top">
                            <Trash className="opacity-0 text-error group-hover:opacity-100" size={24} onClick={(evt) => {
                                evt?.stopPropagation();
                                if (rowData?.type && rowData?.id) {
                                    deleteRule({ catalogId: `${rowData?.type}`, ruleId: rowData?.id })
                                }
                            }} />
                        </Tooltip>
                    }
                </div>,
            name: DataType.ACTION,
            type: DataType.ACTION
        }], [activeRuleTab])

    const getAllRules = async ({ status, offset }) => {
        try {
            setRuleLoading(true)
            const { items, currentPage, totalCount } = await API.getAllRules({
                offset,
                status
            })
            setRuleLoading(false)
            setRuleData({
                pagination: {
                    offset: currentPage,
                    total: totalCount,
                    pageSize: 50
                },
                data: items
            })
        } catch (err) {
            console.log("Error response: ", err)
            setRuleLoading(false)
        }
    }

    const deleteRule = async ({ ruleId, catalogId }) => {
        try {
            if (confirm("Are you sure you want to delete?")) {
                const response = await API.deleteRuleById({ ruleId, catalogId })
                if (response?.catalogInstanceDetails?.status === "SUCCESS") {
                    toast.success('Rule deleted successfully', {
                        position: "bottom-right"
                    })

                    getAllRules({ status: activeRuleTab?.toLowerCase(), offset: 0 })
                } else {
                    toast.error('Unable to delete Rule', {
                        position: "bottom-right"
                    })
                }
            }
        } catch (err) {
            console.log("deleteRule err: ", err)
        }
    }

    useEffect(() => {
        //Get rules for rule tab type
        if (activeRuleTab) {
            getAllRules({ status: activeRuleTab })
        }
    }, [activeRuleTab])

    return (
        <div className="w-full h-full flex flex-col gap-2 relative p-4 px-8">
            <div className="w-full flex items-center justify-between">
                <PageBreadCrumbs />

                <Button variant="primary" className={"text-base"} onClick={() => {
                    navigate("create")
                }}>
                    Create Rule
                </Button>

            </div>
            <div className="h-[90%] flex flex-col gap-4">
                <div role="tablist" className="tabs tabs-bordered items-start w-1/2">
                    {
                        Object.entries(RULE_TABS).map(([_, { key, value }]) => (
                            <React.Fragment key={key}>
                                <input
                                    type="radio"
                                    name="my_tabs_1"
                                    role="tab"
                                    className="tab min-w-40 text-base"
                                    aria-label={`${value}`}
                                    checked={activeRuleTab === key}
                                    onChange={(evt) => {
                                        evt?.stopPropagation();
                                        setActiveRuleTab(key)
                                    }}
                                    onClick={(evt) => {
                                        evt?.stopPropagation();
                                        setActiveRuleTab(key)
                                    }}
                                />
                            </React.Fragment>
                        ))
                    }
                </div>
                <div className="overflow-x-auto h-full">
                    {
                        ruleLoading ?
                            <SkeletonTableView columCount={9} rowCount={10} />
                            :
                            <TableView data={ruleData?.data} columns={TableViewColumns} />
                    }
                </div>
            </div>

        </div>
    )
}

export { NewRule } from "./NewRule";
export { ViewRule } from "./ViewRule";
